import SelectableOptionsMenu from "components/SelectableInput/SelectableOptionsMenu";
import useMappedOptions from "components/SelectableInput/useMappedOptions";
import useMappedValue from "components/SelectableInput/useMappedValue";
import useAllTags from "hooks/useAllTags";
import { Button } from "reactstrap/es";
import { SelectPicker } from "rsuite/esm";
import _ from "underscore";
import useAvailableActions from "./useAvailableActions";
import useReferencedAction from "./useReferencedAction";

const noTags = [];
const labelKey = "Name";
const valueKey = "id";
const colorKey = "Color";

const MenuItem = (label, item, tagsAction) => {
  let tAction = tagsAction === "add" ? "Add" : "Remove";
  let descriptionWord = tAction === "Add" ? "to" : "from";

  return (
    <div style={{ maxWidth: 400 }}>
      <div style={{ fontSize: 15 }} className="text-dark font-weight-500">
        Action {item.Index}: {label}
      </div>
      <div style={{ fontSize: 11 }}>
        {tAction} {descriptionWord} all records modified in Action {item.Index}
      </div>
    </div>
  );
};

const RecordUpdateTags = ({ action, setAction, actions }) => {
  const { availableActions } = useAvailableActions({ actions });
  const { moduleAPIName } = useReferencedAction({ action, actions });
  const { tags: allTags, getTags } = useAllTags(moduleAPIName);

  const getActionInfo = (actionID, tagsAction) => {
    const foundAction = _.findWhere(availableActions, { id: actionID });

    if (!foundAction) {
      return { Name: null, Description: null };
    } else {
      const finalTagsAction = tagsAction || action.TagsAction;
      const tAction = finalTagsAction === "add" ? "Add" : "Remove";
      let descriptionWord = tAction === "Add" ? "to" : "from";

      return {
        Name: `${tAction} Tags ${descriptionWord} Action ${foundAction.Index} Records`,
        Description: `Using the records imported from Action ${foundAction.Index}, ${tAction} selected tags.`,
      };
    }
  };

  const onReferencedActionChange = (newActionID) => {
    const actionInfo = getActionInfo(newActionID);

    const payload = {
      ReferencedAction: newActionID,
      Tags: [],
      ...(actionInfo.Name && { Name: actionInfo.Name }),
      ...(actionInfo.Description && { Description: actionInfo.Description }),
    };

    setAction((prev) => ({ ...prev, ...payload }));
  };

  const selectTag = (t) => {
    setAction((prev) => ({ ...prev, Tags: [...(prev?.Tags ?? []), t.id] }));
  };

  const deselectTag = (t) => {
    setAction((prev) => ({
      ...prev,
      Tags: prev?.Tags?.filter((id) => id !== t.id) ?? [],
    }));
  };

  const updateTagsAction = (newTaction) => {
    const payload = {
      TagsAction: newTaction,
    };

    if (action?.Name && action?.ReferencedAction) {
      const actionInfo = getActionInfo(action.ReferencedAction, newTaction);

      actionInfo.Name && (payload.Name = actionInfo.Name);
      actionInfo.Description && (payload.Description = actionInfo.Description);
    }

    setAction((prev) => ({ ...prev, ...payload }));
  };

  const mappedOptions = useMappedOptions({
    options: allTags,
    groupBy: ["Scope", "Type"],
    labelKey: labelKey,
    ungroupedOptionLabel: "Other",
    groupByLabels: {
      Person: "Your Custom Tags",
      Cloud: "Cloud Tags",
      Module: "Module Tags",
      Workspace: "Workspace Tags",
    },
    sortGroups: true,
    nestedGroupBy: "TagGroup",
  });

  const mappedValue = useMappedValue({
    multiselect: true,
    options: allTags ?? noTags,
    value: getTags(action?.Tags ?? noTags) ?? noTags,
    labelKey: labelKey,
    valueKey: valueKey,
  });

  return (
    <>
      <h3 className="mb-0">Tag Action</h3>
      <div className="mb-2">
        <small>Perform the following action when a match is found.</small>
      </div>
      <div className="d-flex mt-2">
        <Button
          size="sm"
          outline={action?.TagsAction !== "add"}
          onClick={() => updateTagsAction("add")}
        >
          Add
        </Button>
        <Button
          size="sm"
          outline={action?.TagsAction !== "remove"}
          onClick={() => updateTagsAction("remove")}
        >
          Remove
        </Button>
      </div>
      <hr className="my-3" />
      <h3>Select Workflow Action</h3>
      <SelectPicker
        preventOverflow
        data={availableActions}
        style={{ width: "100%" }}
        placeholder="Select Action"
        onChange={onReferencedActionChange}
        value={action?.ReferencedAction}
        labelKey={"Name"}
        valueKey={"id"}
        searchable={false}
        renderMenuItem={(label, item) =>
          MenuItem(label, item, action?.TagsAction)
        }
        renderValue={(_, item) => "Action " + item?.Index + ": " + item?.Name}
      />
      <hr className="my-4" />
      {moduleAPIName && allTags && (
        <div className="border rounded mt-2">
          <h4 className="mt-2 ml-2">Select Tags</h4>
          <hr className="mt-0 mb-2" />
          <SelectableOptionsMenu
            groupBy={["Scope", "Type"]}
            options={mappedOptions}
            value={mappedValue}
            listDisplayMode="list"
            onSelect={selectTag}
            onDeselect={deselectTag}
            nestedGroupBy="TagGroup"
            labelKey={labelKey}
            valueKey={valueKey}
            colorKey={colorKey}
            multiselect
          />
        </div>
      )}
    </>
  );
};

export default RecordUpdateTags;
